export default "__VITE_ASSET__D1ZVyRGy__"